// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alerts-banner {
  background: #0C0907;
  border: 1px solid #EE5B43;
  border-radius: 16px;
  padding: 26px 30px;
  backdrop-filter: blur(4px);
}
 
.alerts-banner-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}
 
.alerts-banner-head svg {
  color: #EE5B43;
  font-size: 24px;
}
 
.alerts-banner-head h3 {
  font-size: 19px;
  color: var(--map-text-primary);
}
 
.alerts-banner > p {
  font-size: 14px;
  color: var(--map-text-muted);
  margin-bottom: 18px;
}
 
.alerts-banner-features {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 22px;
  align-items: flex-start;
}
 
.alerts-banner-features span {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 13.5px;
  color: var(--map-text-muted);
}
 
.alerts-banner-features svg {
  color: #EE5B43;
  font-size: 18px;
  width: 18px;
  flex-shrink: 0;
}
 
.alerts-banner-contact {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 24px;
  padding: 16px 18px;
  background: rgba(238, 91, 67, 0.06);
  border-radius: 10px;
  border: 1px solid rgba(238, 91, 67, 0.15);
}
 
.contact-block {
  display: flex;
  align-items: center;
  gap: 12px;
}
 
.contact-block .contact-icon {
  color: #EE5B43;
  font-size: 18px;
  flex-shrink: 0;
}
 
.contact-block div {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 8px;
  min-width: 0;
  flex: 1 1;
}
 
.contact-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--map-text-muted);
}
 
.contact-email {
  font-size: 14px;
  font-weight: 600;
  color: #EE5B43;
  text-decoration: none;
  transition: color 0.2s;
  word-break: break-word;
  overflow-wrap: break-word;
}
 
.contact-email:hover {
  color: #f07a65;
  text-decoration: underline;
}
 
.presse-block {
  border-top: 1px solid rgba(238, 91, 67, 0.12);
  padding-top: 10px;
}
 
.alerts-banner-actions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 22px;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
 
.alerts-banner-actions .btn-primary {
  background: linear-gradient(135deg, #EE5B43, #d94f39);
  color: var(--map-text-primary);
  border: none;
  padding: 10px 44px;
  margin-top: 18px;
  border-radius: 8px;
  font-size: 17px !important;
  font-weight: 600;
  transition: all 0.3s ease;
  cursor: pointer;
}
 
.alerts-banner-actions .btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(238, 91, 67, 0.35);
}
 
.alerts-banner-download {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13.5px;
  font-weight: 700;
  color: var(--map-text-muted);
  text-decoration: none;
  transition: color 0.3s ease;
}
 
.alerts-banner-download:hover {
  color: #EE5B43;
}
 
.alerts-banner-download svg {
  color: #EE5B43;
}
 
.alerts-banner-note {
  margin-top: 18px;
  font-size: 12px;
  color: var(--map-text-muted);
}
 
.alerts-banner-note a {
  color: #EE5B43;
  font-weight: 700;
  text-decoration: none;
}
 
.alerts-banner-note a:hover {
  text-decoration: underline;
}
 
/* ───────── Réduction de l'espace entre #professionnels et #alertes ───────── */
#alertes {
  padding-top: 48px;
}
 
@media (max-width: 1024px) {
  #alertes {
    padding-top: 36px;
  }
}
 
@media (max-width: 768px) {
  #alertes {
    padding-top: 28px;
  }
}
 
@media (max-width: 480px) {
  #alertes {
    padding-top: 24px;
  }
}
 
/* ───────── Responsive : tablette, contenu centré ───────── */
@media (max-width: 768px) {
  .alerts-banner-head {
    justify-content: center;
    text-align: center;
  }
 
  .alerts-banner > p {
    text-align: center;
  }
 
  .alerts-banner-features {
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    width: fit-content;
  }
 
  .alerts-banner-actions {
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
 
  .alerts-banner-actions .btn-primary {
    width: 100%;
    text-align: center;
  }
 
  .alerts-banner-contact {
    padding: 12px 14px;
  }
 
  .contact-block {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 8px;
  }
 
  .contact-block div {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 4px;
  }
}
 
/* ───────── Responsive : mobile, contenu centré ───────── */
@media (max-width: 480px) {
  .alerts-banner-head {
    flex-direction: column;
    justify-content: center;
    text-align: center;
    gap: 6px;
  }
 
  .alerts-banner > p {
    text-align: center;
  }
 
  .alerts-banner-features {
    align-items: flex-start;
  }
 
  .alerts-banner-features span {
    align-items: flex-start;
  }
 
  .alerts-banner-actions {
    justify-content: center;
    align-items: center;
  }
 
  .alerts-banner-actions .btn-primary {
    width: 100%;
  }
 
  .contact-block {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 6px;
  }
 
  .contact-block div {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 4px;
  }
}
 
@media (max-width: 360px) {
  .alerts-banner {
    padding: 20px 18px;
  }
 
  .alerts-banner-head h3 {
    font-size: 17px;
  }
 
  .alerts-banner-features span {
    font-size: 12.5px;
  }
 
  .contact-label,
  .contact-email {
    font-size: 12.5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/AlertsBanner/AlertsBanner.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gFAAgF;AAChF;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;EACV;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;AACF","sourcesContent":[".alerts-banner {\n  background: #0C0907;\n  border: 1px solid #EE5B43;\n  border-radius: 16px;\n  padding: 26px 30px;\n  backdrop-filter: blur(4px);\n}\n \n.alerts-banner-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n \n.alerts-banner-head svg {\n  color: #EE5B43;\n  font-size: 24px;\n}\n \n.alerts-banner-head h3 {\n  font-size: 19px;\n  color: var(--map-text-primary);\n}\n \n.alerts-banner > p {\n  font-size: 14px;\n  color: var(--map-text-muted);\n  margin-bottom: 18px;\n}\n \n.alerts-banner-features {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 22px;\n  align-items: flex-start;\n}\n \n.alerts-banner-features span {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 13.5px;\n  color: var(--map-text-muted);\n}\n \n.alerts-banner-features svg {\n  color: #EE5B43;\n  font-size: 18px;\n  width: 18px;\n  flex-shrink: 0;\n}\n \n.alerts-banner-contact {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 24px;\n  padding: 16px 18px;\n  background: rgba(238, 91, 67, 0.06);\n  border-radius: 10px;\n  border: 1px solid rgba(238, 91, 67, 0.15);\n}\n \n.contact-block {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n \n.contact-block .contact-icon {\n  color: #EE5B43;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n \n.contact-block div {\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 4px 8px;\n  min-width: 0;\n  flex: 1;\n}\n \n.contact-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--map-text-muted);\n}\n \n.contact-email {\n  font-size: 14px;\n  font-weight: 600;\n  color: #EE5B43;\n  text-decoration: none;\n  transition: color 0.2s;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n \n.contact-email:hover {\n  color: #f07a65;\n  text-decoration: underline;\n}\n \n.presse-block {\n  border-top: 1px solid rgba(238, 91, 67, 0.12);\n  padding-top: 10px;\n}\n \n.alerts-banner-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 22px;\n  flex-wrap: wrap;\n  margin-bottom: 24px;\n}\n \n.alerts-banner-actions .btn-primary {\n  background: linear-gradient(135deg, #EE5B43, #d94f39);\n  color: var(--map-text-primary);\n  border: none;\n  padding: 10px 44px;\n  margin-top: 18px;\n  border-radius: 8px;\n  font-size: 17px !important;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n \n.alerts-banner-actions .btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(238, 91, 67, 0.35);\n}\n \n.alerts-banner-download {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13.5px;\n  font-weight: 700;\n  color: var(--map-text-muted);\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n \n.alerts-banner-download:hover {\n  color: #EE5B43;\n}\n \n.alerts-banner-download svg {\n  color: #EE5B43;\n}\n \n.alerts-banner-note {\n  margin-top: 18px;\n  font-size: 12px;\n  color: var(--map-text-muted);\n}\n \n.alerts-banner-note a {\n  color: #EE5B43;\n  font-weight: 700;\n  text-decoration: none;\n}\n \n.alerts-banner-note a:hover {\n  text-decoration: underline;\n}\n \n/* ───────── Réduction de l'espace entre #professionnels et #alertes ───────── */\n#alertes {\n  padding-top: 48px;\n}\n \n@media (max-width: 1024px) {\n  #alertes {\n    padding-top: 36px;\n  }\n}\n \n@media (max-width: 768px) {\n  #alertes {\n    padding-top: 28px;\n  }\n}\n \n@media (max-width: 480px) {\n  #alertes {\n    padding-top: 24px;\n  }\n}\n \n/* ───────── Responsive : tablette, contenu centré ───────── */\n@media (max-width: 768px) {\n  .alerts-banner-head {\n    justify-content: center;\n    text-align: center;\n  }\n \n  .alerts-banner > p {\n    text-align: center;\n  }\n \n  .alerts-banner-features {\n    align-items: center;\n    margin-left: auto;\n    margin-right: auto;\n    width: fit-content;\n  }\n \n  .alerts-banner-actions {\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n  }\n \n  .alerts-banner-actions .btn-primary {\n    width: 100%;\n    text-align: center;\n  }\n \n  .alerts-banner-contact {\n    padding: 12px 14px;\n  }\n \n  .contact-block {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 8px;\n  }\n \n  .contact-block div {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    gap: 4px;\n  }\n}\n \n/* ───────── Responsive : mobile, contenu centré ───────── */\n@media (max-width: 480px) {\n  .alerts-banner-head {\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    gap: 6px;\n  }\n \n  .alerts-banner > p {\n    text-align: center;\n  }\n \n  .alerts-banner-features {\n    align-items: flex-start;\n  }\n \n  .alerts-banner-features span {\n    align-items: flex-start;\n  }\n \n  .alerts-banner-actions {\n    justify-content: center;\n    align-items: center;\n  }\n \n  .alerts-banner-actions .btn-primary {\n    width: 100%;\n  }\n \n  .contact-block {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 6px;\n  }\n \n  .contact-block div {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    gap: 4px;\n  }\n}\n \n@media (max-width: 360px) {\n  .alerts-banner {\n    padding: 20px 18px;\n  }\n \n  .alerts-banner-head h3 {\n    font-size: 17px;\n  }\n \n  .alerts-banner-features span {\n    font-size: 12.5px;\n  }\n \n  .contact-label,\n  .contact-email {\n    font-size: 12.5px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
